module.exports = __webpack_public_path__ + "static/full05-b03880c98702b5c3ea5869abcf98979f.png";